interface MetaTag {
  name: string
  content: string
}

interface LinkTag {
  rel: string
  href: string
  as?: string
  crossOrigin?: string
  fetchPriority?: 'high' | 'low' | 'auto'
}

/**
 * MOCKUP OFICIAL de la colección (4 tomos + 5 libros extra). Es el elemento LCP
 * del hero y el principal recurso visual de producto de la landing.
 */
export const HERO_IMAGE_URL =
  'https://cdn.magicpatterns.com/uploads/jG7sXmy3MrjB9EGecLCYuv/Mockup.png'

/** La sección de oferta reutiliza el mockup oficial. */
export const BUNDLE_IMAGE_URL = HERO_IMAGE_URL

const PAGE_TITLE =
  '200 Fórmulas de Jabones Artesanales de Glicerina — Fabricá, vendé y emprendé desde casa'

const META_TAGS: MetaTag[] = [
  {
    name: 'description',
    content:
      '200 Fórmulas de Jabones Artesanales de Glicerina: 4 tomos digitales + 5 libros extra de regalo con fórmulas, proporciones, aromas, colorantes y procedimientos paso a paso para fabricar y vender jabones desde casa.',
  },
]

const LINK_TAGS: LinkTag[] = [
  // Warm up the font + image origins before the CSS/image requests are made.
  { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
  { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossOrigin: 'anonymous' },
  { rel: 'preconnect', href: 'https://cdn.magicpatterns.com' },
  // Discover the LCP image as early as possible, at high priority.
  { rel: 'preload', href: HERO_IMAGE_URL, as: 'image', fetchPriority: 'high' },
]

/**
 * Inserts global <meta> and resource-hint <link> tags into <head> once.
 * Existing tags are never duplicated.
 */
export function initHeadMeta(): void {
  if (typeof document === 'undefined') return

  document.title = PAGE_TITLE

  META_TAGS.forEach(({ name, content }) => {
    if (document.querySelector(`meta[name="${name}"]`)) return

    const meta = document.createElement('meta')
    meta.name = name
    meta.content = content
    document.head.appendChild(meta)
  })

  LINK_TAGS.forEach(({ rel, href, as, crossOrigin, fetchPriority }) => {
    if (document.querySelector(`link[rel="${rel}"][href="${href}"]`)) return

    const link = document.createElement('link')
    link.rel = rel
    link.href = href
    if (as) link.as = as
    if (crossOrigin) link.crossOrigin = crossOrigin
    if (fetchPriority) link.setAttribute('fetchpriority', fetchPriority)
    document.head.appendChild(link)
  })
}
